const API = {
    // 提交用户申请试用信息
    submitUserExperience: {
        method: 'post',
        url: '/api/v1/userexperience/post',
    },
    //查询用户申请试用产品分类信息
    getProductSelect: {
        method: 'get',
        url: '/api/v1/userexperience/getproducts',
    },
    // 查询新闻列表
    getArticleList: {
        method: 'get',
        url: 'api/v1/article/list',
    },
    // 查询新闻列表
    getArticleInfo: {
        method: 'get',
        url: '/api/v1/article/get',
    },
    // 提交用户申请试用信息
    submitContactUs: {
        method: 'post',
        url: '/api/v1/contactus/post',
    },
}
export default API
